import './styles.scss'
import React from 'react'
import { COFFEE_CART } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

const CoffeeCart = () => {
  const userDetails = getLocalUserDetails()

  return (
    <div className={`coffee-cart-container ${userDetails?.id ? 'logged-in' : 'guest-user'}`}>
      <img className="coffee-cart-image" src={COFFEE_CART.image} alt="Coffee-Cart" />
    </div>
  )
}

export default CoffeeCart
